import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';

export interface OneformV2LayerContentState {
	featureApp: any;
	params?: any;
	isLayer?: boolean;
}

export const OneformV2LayerContent = (featureAppState: OneformV2LayerContentState, close: () => void): JSX.Element => {
	let serviceRef: FaContentServiceV1 | undefined;

	const handleClose = () => {
		const callback = (serviceRef?.content as any)?.params?.onCloseCallback;
		callback?.();
		close();
	};

	return (
		<div className="oneform" style={{ paddingBottom: '5vh' }}>
			<Container
				wrap={'never'}
				horizontalAlign={'flex-end'}
				verticalAlign={'center'}
				padding={{
					top: {
						[Breakpoints.default]: ContainerPadding.dynamic0130,
						[Breakpoints.b960]: ContainerPadding.dynamic0140,
					},
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b960]: ContainerPadding.dynamic0100,
						[Breakpoints.b1280]: ContainerPadding.dynamic0140,
					},
					bottom: ContainerPadding.dynamic0050,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handleClose}
					aria-label="closePopUp"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			<FeatureAppLoader
				{...featureAppState.featureApp}
				featureAppId={`${featureAppState.featureApp.name}:oneformV2`}
				beforeCreate={(env) => {
					const faContentService = env.featureServices['fa-content-service'] as FaContentServiceV1;
					if (faContentService) {
						serviceRef = faContentService;
						faContentService.content = {
							params: featureAppState.params,
							isLayer: featureAppState.isLayer,
						};
					}
					if (env.featureServices.tracking) {
						(env.featureServices.tracking as any).contextualEventData = {
							event: {
								environment: {
									featureAppId: featureAppState.featureApp.trackingId,
									featureAppIdAppVersion: featureAppState.featureApp.version,
								},
							},
						};
					}
				}}
			/>
		</div>
	);
};
